var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBca(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 1000 313.4",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#0060af;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path20",
    className: "cls-1",
    d: "M147.35,237.88c0-12.49.13-45.88-.18-50,.27-49.68-35.85-84.73-58.67-82-15.79,1.37-29,7.8-36.13,26.33-6.59,17.26-.7,40.22,21.2,45.61,23.41,5.79,37.08,10.6,47,17.39,12.12,8.32,22,24.21,22.28,42.67"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path22",
    className: "cls-1",
    d: "M156.69,313.4c-41.28,0-83.71-10.17-126.08-30.28l-1-.51-.5-1.06c-19-40.13-29.07-84-29.07-127s9.64-84.91,28.67-125l.52-1.06L30.25,28A290.65,290.65,0,0,1,155.62,0c41,0,84.77,10.47,126.58,30.33l1.07.48.49,1.09c19.38,40.87,29.6,84.76,29.6,127,0,42.08-9.81,84.14-29.21,125l-.51,1.07-1.08.5A296,296,0,0,1,156.69,313.4M34.53,277.62c41.16,19.36,82.21,29.14,122.16,29.14a289.37,289.37,0,0,0,122-26.81c18.62-39.59,28.07-80.33,28.07-121,0-40.88-9.86-83.41-28.5-123.08C237.67,16.74,195.3,6.63,155.62,6.63A283.75,283.75,0,0,0,34.17,33.49C15.93,72.34,6.64,113.05,6.64,154.56s9.65,84.14,27.89,123.06"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path24",
    className: "cls-1",
    d: "M137.56,237.9c.08-16-8.86-30.17-20.54-37.78C106.66,193.4,92.75,189,70.31,183.29c-6.93-1.77-14.19-5.71-16.44-10.74-5.94,6-7,19.45-6,27.31C49.11,209,59.75,224,75.77,224.56c9.78.39,22.15-2.11,28.08-3.37,10.23-2.21,26.41,4.2,29,16.69"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path26",
    className: "cls-1",
    d: "M155.62,28.47c-27.16,0-50.62,17.91-50.53,48.9.08,26.06,21,40,28.52,50,11.3,15,17.42,32.79,18,60,.5,21.65.47,43,.58,50.6h6c-.11-7.93-.38-30.62-.07-51.27.41-27.2,6.75-44.3,18.05-59.31,7.55-10,28.49-23.92,28.54-50,.1-31-23.35-48.9-50.48-48.9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path28",
    className: "cls-1",
    d: "M162.51,237.88c0-12.49-.14-45.88.16-50-.26-49.68,35.84-84.73,58.68-82,15.79,1.37,29,7.8,36.14,26.33,6.58,17.26.65,40.22-21.22,45.61-23.42,5.79-37.08,10.6-47,17.39-12.11,8.32-21.31,24.21-21.59,42.67"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path30",
    className: "cls-1",
    d: "M172.29,237.9c-.08-16,8.85-30.17,20.5-37.78,10.4-6.72,24.33-11.14,46.75-16.83,7-1.77,14.19-5.71,16.4-10.74,6,6,7.05,19.45,6,27.31C260.7,209,250.09,224,234.1,224.56c-9.78.39-22.21-2.11-28.11-3.37-10.19-2.21-26.43,4.2-29,16.69"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path32",
    className: "cls-1",
    d: "M180.67,289.59l-3.48-25.35,8.39-1.28c2-.28,4.53.08,5.53,1.36a7.08,7.08,0,0,1,1.64,4.19,5.46,5.46,0,0,1-2.75,5.93v.07c2.73,0,4.38,2,4.85,5.27a16.06,16.06,0,0,1,.07,3.79c-.55,3.34-2.55,4.42-5.92,4.89Zm5.4-4.54a7,7,0,0,0,2.79-.69c1.21-.79,1.1-2.48.93-3.73-.42-2.75-1.14-3.8-4.06-3.37l-1.83.29,1.16,7.64Zm-1.76-11.71c1.11-.18,2.62-.32,3.24-1.37a3.73,3.73,0,0,0,.48-2.83c-.35-1.86-1-3-3.32-2.56l-2.19.35.86,6.5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path34",
    className: "cls-1",
    d: "M217,274.34c.06.47.14,1,.17,1.47.67,4.63-.17,8.45-5.37,9.51-7.69,1.48-9.16-3.3-10.51-10l-.72-3.62c-1.06-6.39-1.52-11.24,6-12.73,4.22-.77,7,.91,8.17,5.12a12.57,12.57,0,0,1,.49,1.87l-4.59.95c-.53-1.58-1.24-4.4-3.31-4.16-3.71.45-2.48,5.07-2.1,7l1.38,6.94c.42,2.1,1.24,5.45,4.45,4.8,2.61-.52,1.48-4.58,1.24-6.25"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path36",
    className: "cls-1",
    d: "M224.38,282l-1.59-26.25,6.18-1.88,12.95,22.82-4.86,1.46-3.07-5.8-5.4,1.62.7,6.59Zm3.76-12.27,3.9-1.13L226.86,258"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path38",
    className: "cls-1",
    d: "M71.84,262.18c1.93-6.19,3.66-10.75,11-8.72,3.95,1.1,6.4,2.84,6.28,7.42a16.41,16.41,0,0,1-.57,3.07L84,262.68c.61-2.53,1-4.54-2.13-5.5-3.61-1-4.49,3.39-5,5.27L75,269.33c-.59,2.05-1.31,5.42,1.87,6.29,2.62.71,4.21-1.87,5.16-5.62l-3.21-.85,1.11-4,7.55,2.43-3.59,13.25-3.47-.94.78-2.8h-.1a4.82,4.82,0,0,1-5.26,2.2c-7.55-2-6.76-7-5-13.57"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path40",
    className: "cls-1",
    d: "M100,273.38l-2.28,10.78-5.12-1.1L98,257.87l8.72,2c5.11,1.1,6.66,3.38,5.93,8.06-.41,2.68-1.74,5.58-5,5.35l0-.05c2.73,1,3,2.34,2.48,4.72-.2,1-1.62,7.17-.64,8.17l0,.75-5.3-1.38c-.22-1.71.53-4.77.83-6.47.3-1.5.78-3.62-.75-4.42a9.07,9.07,0,0,0-3-.92Zm.87-3.91,3.45.93c2.09.31,3.25-.78,3.67-3.31.37-2.32-.11-3.22-2-3.67l-3.7-.75"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path42",
    className: "cls-1",
    d: "M132.78,263.5l5.06.58-2.18,17.71c-1.06,5.61-3.23,8.07-9.4,7.3s-7.78-3.66-7.4-9.31l2.2-17.7,5.1.59L124,280c-.23,1.88-.66,4.67,2.68,5,3,.23,3.63-1.73,4-4.18"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path44",
    className: "cls-1",
    d: "M143.43,290.06,145,264.74l9.73.42c4.6.23,5.8,4,5.65,7.56-.13,2.18-.81,4.61-2.71,5.93a8.43,8.43,0,0,1-5.41,1.3l-3.17-.18-.63,10.62Zm5.75-14.15,2.58.15c2.09.07,3.48-.75,3.66-3.83s-1-3.45-3.73-3.57l-2-.07"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path46",
    className: "cls-1",
    d: "M829.52,52.94l-38.66,70.17c-14.59-11.85-32.41-20.57-55.15-20.57-53.8,0-75.66,40.11-75.66,68.36,0,21,13.73,51.91,61.61,51.91,20.09,0,48.66-14,56.88-20.34L740.3,283.88c-18.22,3.64-24.21,5.89-39.64,6.37C615,292.81,580.35,240.17,580.37,186.39c.06-71.11,63.28-157.58,168.08-157.58,6.42,0,14.27,2.22,21,4.68l6.79-8.68"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path48",
    className: "cls-1",
    d: "M989.05,27l11,255.05H918.52l0-43.74H862.92l-18.29,43.74H756.27L848.65,99.93l-20.83-.13L867.4,27ZM918,105l-31.42,74.18h32.36"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path50",
    className: "cls-1",
    d: "M528.93,27c40.35.23,63.15,22.13,63.15,53.77,0,29.16-24,55-50.44,68.33,27.18,10,29.53,34.52,29.53,51.87,0,41.92-42.06,81.08-96.74,81.08H355.2l46.51-179.59-19.11-.11L421.66,27s74.46-.23,107.27,0M489.35,130.42c8.34,0,23.08-2.11,26.77-18.27,4-17.53-9.8-18-16.43-18L476,94l-8.26,36.38Zm-33.52,45.07-10.91,41.92h27.91c11,0,25.95-5.45,29.62-19.09s-6.84-22.83-17.79-22.83"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBca);
export default __webpack_public_path__ + "static/media/bca.11b7a5c434232127334d6d5f544a4dca.svg";
export { ForwardRef as ReactComponent };